import { api } from "../configs/axiosConfigs";

const BASE = "/SLN/PaymentGateway/TestGateway";

const getApiBase = () =>
  (window.globalConfig?.API_URL || api.defaults.baseURL || "").replace(/\/$/, "");

/** API expects POST; form submit avoids GET 404 and POST 411 without Content-Length. */
const submitTestGatewayAction = (sessionId, action) => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = `${getApiBase()}${BASE}/${action}/${sessionId}`;
  form.style.display = "none";
  document.body.appendChild(form);
  form.submit();
};

const TestGatewayPaymentApi = {
  getSession: async (sessionId) => {
    const response = await api.request({
      url: `${BASE}/Session/${sessionId}`,
      method: "GET",
    });
    return response.data;
  },

  submitSuccess: (sessionId) => submitTestGatewayAction(sessionId, "Success"),

  submitFail: (sessionId) => submitTestGatewayAction(sessionId, "Fail"),

  submitUnknown: (sessionId) => submitTestGatewayAction(sessionId, "Unknown"),
};

export default TestGatewayPaymentApi;
